import Garden1 from '../../../media/GW/Garden Loft.webp'
import Garden2 from '../../../media/GW/Garden Loft.webp'


const Gardenimages =[
Garden1,Garden2
]

export default Gardenimages;